import * as React from 'react';
import ToolIconButton from '../common/ToolIconButton';
import { TTSStatus } from '../../tts/reducers/speech';

// This toolbar assumes the following state machine.
//
//        [IDLE] <---------
//          |              |
//   onPlay |              | onReset
//          ↓              |
//      [PLAYING] -------->|
//         | ↑             |
// onPause | | onResume    |
//         ↓ |             |
//      [PAUSED]-----------

export interface TTSToolbarProps {
  status: TTSStatus;
  rate: number;
  onPlay: () => any;
  onPause: () => any;
  onResume: () => any;
  onReset: () => any;
  onRateChange: (rate: number) => any;
}

export class TTSToolbar extends React.Component<TTSToolbarProps, {}> {
  // NOTE : min/max restriction might be better to be extracted to outside of this component.
  public static readonly MIN_RATE = 1;
  public static readonly MAX_RATE = 100;

  private handleIncreaseRate = (): void => {
    if (this.props.rate <= TTSToolbar.MAX_RATE - 1) {
      this.props.onRateChange(this.props.rate + 1);
    }
  }

  private handleDecreaseRate = (): void => {
    if (this.props.rate >= TTSToolbar.MIN_RATE + 1) {
      this.props.onRateChange(this.props.rate - 1);
    }
  }

  public render() {
    const { status } = this.props;
    const enablePlay = (status === TTSStatus.Idle);
    const enablePause = (status === TTSStatus.Playing);
    const enableResume = (status === TTSStatus.Paused);
    const enableReset = (status !== TTSStatus.Idle);
    const enableRate = (status === TTSStatus.Idle);

    return <>
      <ToolIconButton
        onClick={this.props.onPlay}
        disabled={!enablePlay}
        text="再生"
        title="再生"
        ariaLabel="Play" />
      <ToolIconButton
        onClick={this.props.onPause}
        disabled={!enablePause}
        text="一時停止"
        title="一時停止"
        ariaLabel="Pause" />
      <ToolIconButton
        onClick={this.props.onResume}
        disabled={!enableResume}
        text="再開"
        title="再開"
        ariaLabel="Resume" />
      <ToolIconButton
        onClick={this.props.onReset}
        disabled={!enableReset}
        text="停止"
        title="停止"
        ariaLabel="Stop" />
      <ToolIconButton
        onClick={() => alert('not implemented')}
        text="前に戻る"
        title="前に戻る"
        ariaLabel="Prev" />
      <ToolIconButton
        onClick={() => alert('not implemented')}
        text="次に進む"
        title="次に進む"
        ariaLabel="Next" />
      <ToolIconButton
        onClick={this.handleIncreaseRate}
        disabled={!enableRate}
        text="速度+"
        title="速度+"
        ariaLabel="Rate up" />
      <ToolIconButton
        onClick={this.handleDecreaseRate}
        disabled={!enableRate}
        text="速度-"
        title="速度-"
        ariaLabel="Rate down" />
      <ToolIconButton
        onClick={() => alert('not implemented')}
        text="音量+"
        title="音量+"
        ariaLabel="Volume plus" />
      <ToolIconButton
        onClick={() => alert('not implemented')}
        text="音量-"
        title="音量-"
        ariaLabel="Volume minus" />
    </>;
  }
}
